export function resolveText<TArgs>(
  enabled: boolean,
  value?: string | ((args: TArgs) => string),
  args?: TArgs
): string {
  if (!enabled || !value) return "";
  return typeof value === "function" ? value(args as TArgs) : value;
}
